import { COLOR_OPTIONS } from 'config/style';
import { RiskLevelEnum } from 'querys/regional-overview/regional-overview.query.models';

export const getBackgroundColor = (risk: RiskLevelEnum) => {
  switch (risk) {
    case RiskLevelEnum.HIGH:
      return COLOR_OPTIONS.RED_20;
    case RiskLevelEnum.MEDIUM:
      return COLOR_OPTIONS.YELLOW_20;
    case RiskLevelEnum.LOW:
    default:
      return COLOR_OPTIONS.NEUTRAL_10;
  }
};

export const getIconColor = (risk: RiskLevelEnum) => {
  switch (risk) {
    case RiskLevelEnum.HIGH:
      return COLOR_OPTIONS.RED_60;
    case RiskLevelEnum.MEDIUM:
      return COLOR_OPTIONS.YELLOW_50;
    case RiskLevelEnum.LOW:
    default:
      return COLOR_OPTIONS.GREEN_60;
  }
};

export const getTextColor = (risk: RiskLevelEnum) => {
  switch (risk) {
    case RiskLevelEnum.HIGH:
    case RiskLevelEnum.MEDIUM:
      return COLOR_OPTIONS.NEUTRAL_100;
    case RiskLevelEnum.LOW:
    default:
      return COLOR_OPTIONS.BLUE_70;
  }
};

export const getDiseaseTranslationKey = (diseaseName: string): string => {
  const slug = diseaseName.replaceAll(' ', '_').replaceAll('-', '_').toLocaleLowerCase();
  return `general.diseases.${slug}.full`;
};
